import { Stack, SxProps, useTheme } from '@mui/material';
import Link from '@mui/material/Link';
import { ReactElement } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ICONS } from '@/assets/icons';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import { TypographyProps } from '@/components/atoms/Typography/types';
import Iconify from '@/components/Iconify';

type TLink = {
  href?: string;
  name: string;
  icon?: ReactElement;
  external?: boolean;
  sx?: SxProps;
};

type PreLinkProps = {
  link: TLink;
  typographyProps?: TypographyProps;
};

export function PreLink({ link, typographyProps }: PreLinkProps) {
  const { href, name, icon, external = false, sx } = link;
  const theme = useTheme();
  const variant = typographyProps?.variant ?? 'body2';
  return (
    <Link
      key={name}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        ml: 0.5,
        color: theme.palette.link,
        ...sx,
      }}
      component={RouterLink}
      to={href || '#'}
      target={external ? '_blank' : undefined}
      rel="noopener noreferrer"
      underline="always"
    >
      <Stack>
        <PTypography variant={variant} color={(theme) => theme.palette.link} {...typographyProps}>
          {name}
        </PTypography>
      </Stack>
      {!icon ? (
        external ? (
          <Stack alignItems="center">
            <Iconify icon={ICONS.OPEN_IN_NEW} width={18} sx={{ color: typographyProps?.color }} />
          </Stack>
        ) : null
      ) : (
        icon
      )}
    </Link>
  );
}
